import { ActivatedRoute, Router } from "@angular/router";
import { EmailFeedbackDto } from '../../shared/model/email-feedback-dto.model';
import { AccountService } from '../../core/auth/account.service';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UserEmailFeedbackService } from './user-email-feedback.service';
import { JhiLanguageService } from '../../ng-jhipster/language';
import moment from 'moment';
import * as i0 from "@angular/core";
import * as i1 from "../../core/auth/account.service";
import * as i2 from "@angular/router";
import * as i3 from "@ng-bootstrap/ng-bootstrap";
import * as i4 from "./user-email-feedback.service";
import * as i5 from "../../ng-jhipster/language";
import * as i6 from "../../shared/unauth-header/unauth-header.component";
import * as i7 from "@angular/common";
import * as i8 from "../../shared/alert/alert-error.component";
import * as i9 from "../../ng-jhipster/language/jhi-translate.directive";
import * as i10 from "@angular/material/checkbox";
import * as i11 from "@angular/forms";
import * as i12 from "@fortawesome/angular-fontawesome";
import * as i13 from "@angular/material/input";
import * as i14 from "@angular/cdk/text-field";
import * as i15 from "@ngx-translate/core";
const _c0 = function () { return { standalone: true }; };
function EmailFeedbackComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelement(1, "jhi-alert-error");
    i0.ɵɵelementStart(2, "div", 7);
    i0.ɵɵelement(3, "h3", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "div", 9);
    i0.ɵɵelementStart(5, "div", 10);
    i0.ɵɵelementStart(6, "div", 11);
    i0.ɵɵelementStart(7, "mat-checkbox", 12);
    i0.ɵɵlistener("ngModelChange", function EmailFeedbackComponent_div_5_Template_mat_checkbox_ngModelChange_7_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.isGood = $event; })("change", function EmailFeedbackComponent_div_5_Template_mat_checkbox_change_7_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.onGoodChange($event.checked); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 13);
    i0.ɵɵelement(9, "fa-icon", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(10, "span", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 16);
    i0.ɵɵelementStart(12, "mat-checkbox", 12);
    i0.ɵɵlistener("ngModelChange", function EmailFeedbackComponent_div_5_Template_mat_checkbox_ngModelChange_12_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6.canBeBetter = $event; })("change", function EmailFeedbackComponent_div_5_Template_mat_checkbox_change_12_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.onCanBeBetterChange($event.checked); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 17);
    i0.ɵɵelement(14, "fa-icon", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(15, "span", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 7);
    i0.ɵɵelement(17, "span", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 21);
    i0.ɵɵelementStart(19, "textarea", 22, 23);
    i0.ɵɵlistener("ngModelChange", function EmailFeedbackComponent_div_5_Template_textarea_ngModelChange_19_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.emailFeedbackDto.comment = $event; });
    i0.ɵɵpipe(21, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "div", 24);
    i0.ɵɵelementStart(23, "button", 25);
    i0.ɵɵlistener("click", function EmailFeedbackComponent_div_5_Template_button_click_23_listener() { i0.ɵɵrestoreView(_r4); const ctx_r9 = i0.ɵɵnextContext(); return ctx_r9.submitFeedback(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngModel", ctx_r0.isGood);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngModel", ctx_r0.canBeBetter);
    i0.ɵɵadvance(7);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(21, 6, "emailFeedback.type"));
    i0.ɵɵproperty("ngModel", ctx_r0.emailFeedbackDto.comment)("maxLength", 500)("ngModelOptions", i0.ɵɵpureFunction0(8, _c0));
} }
function EmailFeedbackComponent_div_6_a_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "a", 30);
} }
function EmailFeedbackComponent_div_6_a_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "a", 31);
} }
function EmailFeedbackComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵelementStart(1, "div", 7);
    i0.ɵɵelement(2, "h3", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 7);
    i0.ɵɵtemplate(4, EmailFeedbackComponent_div_6_a_4_Template, 1, 0, "a", 28);
    i0.ɵɵtemplate(5, EmailFeedbackComponent_div_6_a_5_Template, 1, 0, "a", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r1.isAuthenticated);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.isAuthenticated);
} }
const GOOD = "GOOD";
const CAN_BE_BETTER = "CAN_BE_BETTER";
export class EmailFeedbackComponent {
    constructor(accountService, activatedRoute, modalService, router, userEmailFeedbackService, languageService) {
        this.accountService = accountService;
        this.activatedRoute = activatedRoute;
        this.modalService = modalService;
        this.router = router;
        this.userEmailFeedbackService = userEmailFeedbackService;
        this.languageService = languageService;
        this.emailFeedbackDto = new EmailFeedbackDto();
    }
    ngOnInit() {
        this.isAuthenticated = this.accountService.isAuthenticated();
        this.emailFeedbackDto.publicId = this.activatedRoute.snapshot.queryParams[EmailFeedbackComponent.PUBLIC_ID_PARAMETER_NAME];
        this.emailFeedbackDto.emailName = this.activatedRoute.snapshot.queryParams[EmailFeedbackComponent.EMAIL_NAME_PARAMETER_NAME];
        this.emailFeedbackDto.feedbackType = this.activatedRoute.snapshot.queryParams[EmailFeedbackComponent.FEEDBACK_TYPE_PARAMETER_NAME];
        const sendDate = this.activatedRoute.snapshot.queryParams[EmailFeedbackComponent.SEND_DATE_PARAMETER_NAME];
        if (sendDate) {
            this.emailFeedbackDto.emailSendDate = moment(sendDate);
        }
        const langKey = this.activatedRoute.snapshot.queryParamMap.get(EmailFeedbackComponent.LANG_KEY_PARAMETER_NAME);
        this.isGood = this.emailFeedbackDto.feedbackType === GOOD;
        this.canBeBetter = !this.isGood;
        console.log(this.emailFeedbackDto);
        if (langKey) {
            this.languageService.changeLanguage(langKey);
        }
    }
    close() {
        this.modalService.dismissAll();
        this.router.navigate(['/login']).then();
    }
    onGoodChange(c) {
        this.isGood = c;
        this.canBeBetter = !c;
        this.emailFeedbackDto.feedbackType = c ? GOOD : CAN_BE_BETTER;
    }
    onCanBeBetterChange(c) {
        this.isGood = !c;
        this.canBeBetter = c;
        this.emailFeedbackDto.feedbackType = !c ? GOOD : CAN_BE_BETTER;
    }
    submitFeedback() {
        this.userEmailFeedbackService.submitEmailFeedback(this.emailFeedbackDto).subscribe(res => {
            this.submitted = true;
        });
    }
}
EmailFeedbackComponent.PUBLIC_ID_PARAMETER_NAME = 'publicId';
EmailFeedbackComponent.FEEDBACK_TYPE_PARAMETER_NAME = 'feedbackType';
EmailFeedbackComponent.EMAIL_NAME_PARAMETER_NAME = 'emailName';
EmailFeedbackComponent.LANG_KEY_PARAMETER_NAME = 'langKey';
EmailFeedbackComponent.SEND_DATE_PARAMETER_NAME = 'sendDate';
EmailFeedbackComponent.ɵfac = function EmailFeedbackComponent_Factory(t) { return new (t || EmailFeedbackComponent)(i0.ɵɵdirectiveInject(i1.AccountService), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i3.NgbModal), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i4.UserEmailFeedbackService), i0.ɵɵdirectiveInject(i5.JhiLanguageService)); };
EmailFeedbackComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: EmailFeedbackComponent, selectors: [["email-feedback"]], decls: 7, vars: 2, consts: [[1, "olha-theme", "d-flex", "justify-content-center", 2, "height", "85%"], [1, "col-sm-12", "col-md-12", "col-lg-10", "col-xl-10", "bg-2", "mt-5", "p-5", "d-flex", "justify-content-center", 2, "height", "auto!important"], [1, "col-sm-12", "col-md-10", "col-lg-8", "col-xl-6", "card", "p-4", "mt-5", "mb-5"], [1, "main-body"], ["class", "modal-body", 4, "ngIf"], ["class", "modal-body text-center", 4, "ngIf"], [1, "modal-body"], [1, "mb-3"], ["jhiTranslate", "emailFeedback.whatDoYouThink"], ["id", "circle"], [1, "d-flex", "justify-content-start", "mr-5", "mb-3"], [1, "d-flex", "justify-content-between", "align-items-center"], [1, "check-box", 3, "ngModel", "ngModelChange", "change"], [1, "circle-good", "d-flex", "justify-content-center", "align-items-center"], ["icon", "smile", 1, "face", "smile"], ["jhiTranslate", "emailFeedback.good", 1, "ml-2"], [1, "d-flex", "justify-content-between", "align-items-center", "ml-5"], [1, "circle-frown", "d-flex", "justify-content-center", "align-items-center"], ["icon", "frown", 1, "face", "frown"], ["jhiTranslate", "emailFeedback.canBeBetter", 1, "ml-2"], ["jhiTranslate", "emailFeedback.tellUsMore"], [1, "mb-4"], ["matInput", "", "cdkTextareaAutosize", "", 1, "p-3", 3, "ngModel", "maxLength", "ngModelOptions", "placeholder", "ngModelChange"], ["autosize", "cdkTextareaAutosize"], [1, "d-flex", "justify-content-center"], ["type", "button", "jhiTranslate", "emailFeedback.send", 1, "btn", "btn-primary", 3, "click"], [1, "modal-body", "text-center"], ["jhiTranslate", "emailFeedback.thanksForYourFeedback"], ["class", "btn btn-primary", "routerLink", "/login", "jhiTranslate", "login.form.logIn", 4, "ngIf"], ["class", "btn btn-primary", "routerLink", "/", "jhiTranslate", "global.menu.home", 4, "ngIf"], ["routerLink", "/login", "jhiTranslate", "login.form.logIn", 1, "btn", "btn-primary"], ["routerLink", "/", "jhiTranslate", "global.menu.home", 1, "btn", "btn-primary"]], template: function EmailFeedbackComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "unauth-header");
        i0.ɵɵelementStart(1, "div", 0);
        i0.ɵɵelementStart(2, "div", 1);
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵtemplate(5, EmailFeedbackComponent_div_5_Template, 24, 9, "div", 4);
        i0.ɵɵtemplate(6, EmailFeedbackComponent_div_6_Template, 6, 2, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", !ctx.submitted);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.submitted);
    } }, directives: [i6.UnauthHeaderComponent, i7.NgIf, i8.AlertErrorComponent, i9.JhiTranslateDirective, i10.MatCheckbox, i11.NgControlStatus, i11.NgModel, i12.FaIconComponent, i13.MatInput, i14.CdkTextareaAutosize, i11.DefaultValueAccessor, i2.RouterLinkWithHref], pipes: [i15.TranslatePipe], styles: [".container[_ngcontent-%COMP%]{margin:90px auto 40px !important;height:auto !important;width:auto;max-width:1169px !important;padding-top:30px;text-align:center}.check-box[_ngcontent-%COMP%]{margin-right:8px}.face[_ngcontent-%COMP%]{font-size:20px}.smile[_ngcontent-%COMP%]{color:#44a38b}.frown[_ngcontent-%COMP%]{color:#af3b6e}textarea[_ngcontent-%COMP%]{width:100%;border:1px solid #a6a6a6;border-radius:10px;min-height:200px}button[_ngcontent-%COMP%]{width:200px;height:50px}.circle-good[_ngcontent-%COMP%]{background:#fff;border-radius:50%;border:8px solid #44a38b;width:40px;height:40px}.circle-frown[_ngcontent-%COMP%]{background:#fff;border-radius:50%;border:8px solid #af3b6e;width:40px;height:40px}@media(min-width: 768px){.container[_ngcontent-%COMP%]{margin:120px auto 130px !important;padding-top:50px}}"] });
